import { combineReducers, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

// http request
import manageHttpReducer from './http-request/reducer';
import saga from './http-request/saga';
import httpActions from './http-request/actions';
import httpProps from './http-request/wrapper';

import { Provider } from 'react-redux';
import React from 'react';

const rootReducer = combineReducers({
	manageHttpReducer
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(saga);

export const actions = {
	...httpActions
};

export const selector = {};

export const mapHttpToProps = httpProps;

class ReduxStoreProvider extends React.Component {
	render() {
		return <Provider store={store}>{this.props.children}</Provider>;
	}
}

export default ReduxStoreProvider;



// WEBPACK FOOTER //
// ./src/libraries/reducers/index.js